import React, { useState, useEffect } from 'react';
import { ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import LinkIncome from '../../../Repayment/LinkIncome';
import { remainingAmount, matchTotal } from '../../../../../../../../jsx/utils/factId5000';

const LinkSalePopUp = (props) => {
    const [state, setState] = useState({
        income: {},
        noMatch: false,
        parts: {},
        max: {},
        total: {},
        errors: {},
    });

    useEffect(() => {
        const { SALES, checkedPayments, transfer } = props;
        if (!checkedPayments) return;
        
        const initialParts = props.initialParts || {};
        let parts = {};
        let max = {};
        let total = {};
        let errors = {};

        checkedPayments.forEach((ID) => {
            // Depuis l'écran de détail, la vente vient des props : elle n'est pas dans la liste
            // du store, et se fier à SALES seul laissait le formulaire vide.
            const sale = (transfer && transfer.id === ID) ? transfer : (SALES && SALES[ID]);
            if (!sale) return;

            // Le montant proposé et la borne haute sont le reste à pointer, non le prix de la
            // vente : total_price laissait saisir un montant que le back refuse ensuite.
            const remaining = remainingAmount(sale);
            const reference = matchTotal(sale);
            const available = remaining === null ? reference : remaining;

            parts[ID] = typeof initialParts[ID] === "number" ? initialParts[ID] : available;
            max[ID] = available;
            total[ID] = reference;
            errors[ID] = "";
        });

        setState({
            parts,
            max,
            total,
            errors,
        });

        props.handleChangeParts(parts);
    }, [props.SALES, props.checkedPayments, props.initialParts]);

    const handlePartChange = (e, ID) => {
        const { name, value } = e.target;
        const { parts } = state;
        let cp = { ...parts };

        cp[ID] = parseFloat(value);

        setState({
            ...state,
            parts: cp,
        });

        props.handleChangeParts(cp);
    };

    const rmPayment = (ID) => {
        const { parts } = state;
        let cp = { ...parts };
        delete cp[ID];

        setState({
            ...state,
            parts: cp,
        });

        props.rmPayment(ID);
    };

    const { SALES, CLIENTS, checkedPayments, totalPay, handleClose, handleChange, incomeID, getIncomeInfo, handleSubmitLink} = props;
    
    if (!checkedPayments || !Array.isArray(checkedPayments) || checkedPayments.length === 0) {
        return null;
    }
    
    return (
        <LinkIncome 
            title={props.title || "Pointer les ventes"} 
            totalPay={totalPay}
            handleClose={handleClose}
            handleChange={handleChange}
            incomeID={incomeID}
            getIncomeInfo={getIncomeInfo}
            handleSubmitLink={handleSubmitLink}
        >
            {checkedPayments.map((ID, index) => {
                const sale = (props.transfer && props.transfer.id === ID) ? props.transfer : SALES?.[ID];
                const clientId = sale?.client_id;
                const client = CLIENTS?.[clientId];
                
                if (!sale) return null;
                
                const clientName = client 
                    ? `${client.client_firstname || ''} ${client.client_lastname || ''}`.trim()
                    : `Client ID: ${clientId || 'N/A'}`;
                    
                const creationDate = sale.creation_date 
                    ? new Date(sale.creation_date).toLocaleString('fr-FR')
                    : 'Date non disponible';
                
                return (
                    <ListItem key={ID}>
                        <ListItemAvatar onClick={() => rmPayment(ID)} style={{ cursor: "pointer" }}>
                            <CloseRounded color="error" />
                        </ListItemAvatar>
                        <ListItemText
                            primary={clientName}
                            secondary={creationDate}
                        />
                        <ListItemSecondaryAction>
                            <InputText
                                required
                                label="Montant"
                                type="number"
                                name="amount"
                                value={state.parts?.[ID] || ''}
                                onChange={(e) => handlePartChange(e, ID)}
                                error={state.errors?.[ID]}
                                helperText={`Max: ${state.max?.[ID] || 0} / ${state.total?.[ID] || 0}`}
                                size="small"
                            />
                        </ListItemSecondaryAction>
                        <hr />
                    </ListItem>
                );
            })}
        </LinkIncome>
    );
};

export default LinkSalePopUp;
